export const sharedProtocolsList = {
  viewProtocol: "View protocol",
  viewProtocolAriaLabel: "View {{protocolName}} protocol",
  viewProtocolNameOnlyAriaLabel: "View {{protocolName}}",
  thumbnailOverflow: "+{{count}}",
  thumbnailProductLabel: "{{protocolName}} product {{index}}",
  thumbnailResourceLabel: "{{protocolName}} resource {{index}}",
  thumbnailOverflowLabel: "{{count}} more items in {{protocolName}}",
};
